import dayjs from "dayjs";
import "dayjs/locale/fr";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);
dayjs.locale("fr");

export const formatExperiencePeriod = (start: string, end: string, present: boolean) => {
  if (!start) return "";
  const format = (value: string) => {
    const date = dayjs(value, "YYYY-MM", true);
    return date.isValid() ? date.format("MMMM YYYY") : value;
  };
  if (present) return `${format(start)} – Aujourd’hui`;
  return end ? `${format(start)} – ${format(end)}` : format(start);
};

export const stripHtml = (value = "") =>
  value
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .trim();
